$(window).on('load', function(){
// script for main product section reviews start
  setTimeout(function(){
    var html = $("#inhair-product .loox-rating .loox-rating-content").html(); 
    $("#inhair-product .loox-rating .loox-rating-content").remove();
    $("#inhair-product .loox-rating .avg_rating").before("<div class="loox-rating-content">"+ html + "</div>");       
  }, 3000);
// script for main product section reviews end
    
// script to autoplay the video for steps section on page load, variant change and changing slides start
  $('#steps-image-text.video .image-with-text-video-section__media video').trigger('play');
  $('#inhair-product fieldset').change(function(){
    setTimeout(function(){
      $('#steps-image-text.video .image-with-text-video-section__media video').trigger('play'); 
    }, 10);
  });
  $('thumbnail-slider .thumbnail-list__item').click(function(){
    setTimeout(function(){
      $('#steps-image-text.video .image-with-text-video-section__media video').trigger('play'); 
    }, 10);
  });
// script to autoplay the video for steps section on page load, variant change and changing slides end
    
});    

/*PDP Subscribe & Save an extra 10%? text change by script start*/
// $(document).ready(function() {
//   setTimeout(function(){
//      var paragraphs = document.getElementsByClassName("rc-checkbox__subscription");
// if (paragraphs.length > 0) {
//   paragraphs[0].innerHTML = "Abonnez-vous et économisez 10%";
// }
//    var paragraphs = document.getElementsByClassName("rc-checkbox__descriptor");
// if (paragraphs.length > 0) {
//   paragraphs[0].innerHTML = "Sans engagement - annulez à tout moment";
// }   
// $('.rc-checkbox').append('<span class="recommended">RECOMMENDED</span>');     
//   }, 2000);
// });  
/*PDP Subscribe & Save an extra 10%? text change by script end*/

// script to change the add to cart button text in sticky form on variant change start

$(document).ready(function(){
  function selling_plan(){
    var selling_plan = $('#inhair-product .product-form .shopify-product-form [name="selling_plan"]').attr("value");
    $('.template-product .product-sticky-cart .shopify-product-form [name="selling_plan"]').attr("value", selling_plan);
  }
  
  var add_to_cart_text = $('.template-product .product-sticky-cart .product-form__submit').html(); 
  $('.template-product #inhair-product variant-radios').change(function(){ 
    setTimeout(function(){ 
      $('.template-product .product-sticky-cart .product-form__submit').html(add_to_cart_text);
      selling_plan();
    }, 1000);
  });
  // Vérifier si la checkbox avec l'ID rc-checkbox1 est présente sur la page

  // Ajouter un délai de 1 seconde avant de décocher la checkbox
  // setTimeout(function() {
  //   if ($('#rc-checkbox1').length) {
  //     $('#rc-checkbox1').prop('checked', false);
  //     selling_plan();
  //   } }, 3000); // 1000 millisecondes = 1 seconde
});

// script to change the add to cart button text in sticky form on variant change end

// script to add and remove selling plan from sticky add to cart based on the option selected start

$(window).on('load',function(){
  function selling_plan(){
    var selling_plan = $('#inhair-product .product-form .shopify-product-form [name="selling_plan"]').attr("value");
    $('.template-product .product-sticky-cart .shopify-product-form [name="selling_plan"]').attr("value", selling_plan);
  }
  setTimeout(function(){
    selling_plan();
    $('#inhair-product .rc-widget #rc-checkbox1').change(function(){
      selling_plan();    
    });
  }, 1000);
  // Vérifier si la checkbox avec l'ID rc-checkbox1 est présente sur la page

  // Ajouter un délai de 1 seconde avant de décocher la checkbox
  // setTimeout(function() {
  //   if ($('#rc-checkbox1').length) {
  //     $('#rc-checkbox1').prop('checked', false);
  //     selling_plan();
  //   } }, 3000); // 1000 millisecondes = 1 seconde
});

// script to add and remove selling plan from sticky add to cart based on the option selected end

